import { mktSiteTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

export const mktSiteCode = (state = defaultState, action) =>
  commonReducer(actionTypes.GET_CODE, state, action);
